function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2239",
    xmlns: "http://www.w3.org/2000/svg",
    width: 569.654,
    height: 353.183,
    viewBox: "0 0 569.654 353.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aakk7g5lba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 559",
    style: {
      fill: "none"
    },
    d: "M0 0h569.654v353.183H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zhtvnuptkb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 549",
    transform: "translate(148.529 85.124)",
    style: {
      fill: "none"
    },
    d: "M0 0h317v223.745H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rj603xjtjc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3098",
    d: "M17.984 103.733a38.682 38.682 0 1 0 38.682-38.682 38.683 38.683 0 0 0-38.682 38.682",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ng3dbatjd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 551",
    transform: "translate(82.34 141.863)",
    style: {
      fill: "none"
    },
    d: "M0 0h4.971v8.31H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6qqnm1ypze"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3116",
    d: "M501.69 181.646a31.666 31.666 0 1 0 31.665-31.667 31.666 31.666 0 0 0-31.665 31.667",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t8ijaast0f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3153",
    d: "M480.632 0a46.221 46.221 0 1 0 46.218 46.224v-.006A46.22 46.22 0 0 0 480.632 0z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4rsrvikkeg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 554",
    transform: "translate(429.703 131.871)",
    style: {
      fill: "none"
    },
    d: "M0 0h42.742v8.331H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u6r8zk319h"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 555",
    transform: "translate(452.185 142.87)",
    style: {
      fill: "none"
    },
    d: "M0 0h15.929v13.446H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h43eoagsti"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3183",
    d: "M208.924 51.272a33.852 33.852 0 1 0 33.852-33.852 33.852 33.852 0 0 0-33.852 33.852",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zw07f9n2sj"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3203",
    d: "M0 227.04a47.674 47.674 0 1 0 47.675-47.673A47.676 47.676 0 0 0 0 227.04",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2192",
    style: {
      clipPath: "url(#aakk7g5lba)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2160"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2159",
    style: {
      clipPath: "url(#zhtvnuptkb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3059",
    d: "M442.9 124.017h-25.153a7.735 7.735 0 0 1-7.736-7.734v-9.035a7.737 7.737 0 0 1 7.734-7.742H442.9a7.744 7.744 0 0 1 7.742 7.742v9.032a7.741 7.741 0 0 1-7.742 7.737",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3060",
    d: "M232.444 141.579h-61.031a11.627 11.627 0 0 1-11.625-11.625V116.39a11.627 11.627 0 0 1 11.625-11.625h61.03a11.627 11.627 0 0 1 11.625 11.625v13.564a11.627 11.627 0 0 1-11.625 11.625",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3061",
    d: "M446.731 139.64h-32.809a10.1 10.1 0 0 1-10.1-10.1v-11.774a10.1 10.1 0 0 1 10.1-10.094h32.809a10.1 10.1 0 0 1 10.1 10.094v11.778a10.1 10.1 0 0 1-10.1 10.1",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3062",
    d: "m289.929 85.123-32.519 36.969h135.719l-32.522-36.969z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 543",
    transform: "translate(148.529 120.103)",
    style: {
      fill: "#0099d6"
    },
    d: "M0 0h110.959v34.906H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 544",
    transform: "translate(259.488 120.103)",
    style: {
      fill: "#007dd2"
    },
    d: "M0 0h131.7v34.906H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 545",
    transform: "translate(391.188 120.103)",
    style: {
      fill: "#0099d6"
    },
    d: "M0 0h74.341v34.906H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 546",
    transform: "translate(148.529 155.009)",
    style: {
      fill: "#1d175b"
    },
    d: "M0 0h317v113.411H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 547",
    transform: "translate(148.529 268.42)",
    style: {
      fill: "#0099d6"
    },
    d: "M0 0h317v18.714H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 548",
    transform: "translate(148.529 283.512)",
    style: {
      fill: "#222"
    },
    d: "M0 0h317v7.283H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3063",
    d: "M321.989 308.868a87.182 87.182 0 1 1 87.186-87.178 87.271 87.271 0 0 1-87.188 87.175",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3064",
    d: "M402.586 221.7a80.584 80.584 0 1 1 0-.032z",
    style: {
      fill: "#1d175b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3065",
    d: "M383.087 221.687a61.1 61.1 0 1 1 0-.006z",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3066",
    d: "M351.991 221.688a30 30 0 1 1-30.006-30 30 30 0 0 1 30.006 30",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3067",
    d: "M321.841 212.8a11.994 11.994 0 1 1-12-11.993 11.994 11.994 0 0 1 12 11.993",
    style: {
      fill: "#c1bbb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3068",
    d: "M310.757 212.512a5.047 5.047 0 1 1-5.048-5.047 5.047 5.047 0 0 1 5.048 5.047",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3069",
    d: "M300.763 270.134a49.4 49.4 0 0 1-22.231-21.621 6.631 6.631 0 1 1 11.608-6.413c.039.071.077.142.113.214a36.078 36.078 0 0 0 16.254 15.865 6.634 6.634 0 1 1-5.685 11.988l-.059-.028",
    style: {
      fill: "#99d6ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3070",
    d: "M272.044 225.451a69.08 69.08 0 0 1-.136-3.944c-.284-23.04 14.35-47.13 43.094-50.387a6.627 6.627 0 0 1 1.59 13.158l-.04.005c-21.36 2.611-31.092 18.98-31.387 37.224 0 .993.039 1.976.116 2.935a6.608 6.608 0 0 1-6.066 7.109h-.041c-.179 0-.358.011-.517.011a6.625 6.625 0 0 1-6.613-6.114",
    style: {
      fill: "#99d6ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3071",
    d: "M428.615 139.641a7.266 7.266 0 1 1-7.266-7.266 7.266 7.266 0 0 1 7.266 7.266z",
    style: {
      fill: "#3b2e87"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2162"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2161",
    style: {
      clipPath: "url(#aakk7g5lba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3072",
    d: "M56.666 65.051a38.682 38.682 0 1 1-38.682 38.682 38.683 38.683 0 0 1 38.682-38.682",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3073",
    d: "M56.666 65.051a38.682 38.682 0 1 1-38.682 38.682 38.683 38.683 0 0 1 38.682-38.682",
    style: {
      fill: "#5d50a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2167"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2166",
    style: {
      clipPath: "url(#rj603xjtjc)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3074",
    d: "M65.583 297.4a16.52 16.52 0 0 1-4.532-9.643l-5.351 5.468.378 7.456c3.392-.8 6.72-1.566 9.5-3.276",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3075",
    d: "M65.584 297.4c-2.783 1.71-6.111 2.478-9.5 3.276q.1 2.067.209 4.135a3.174 3.174 0 0 0 .612 2.079c.725.764 1.963.612 2.988.368a46 46 0 0 0 7.383-2.439c1.208-.517 2.574-1.34 2.613-2.655s-1.24-2.2-2.292-2.969a15.8 15.8 0 0 1-2.013-1.8",
    style: {
      fill: "#222154"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3076",
    d: "M98.072 285.111c-.383-.118-.77-.22-1.148-.355a16.615 16.615 0 0 1-6.164-3.673c-1.66-1.649-1.572-3.8-1.749-6.06l-6.854 5.665a45.576 45.576 0 0 1 1.679 8.3 24.756 24.756 0 0 0 14.236-3.877",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3077",
    d: "M107.661 287.451a3.711 3.711 0 0 0-1.458-.52c-2.724-.548-5.479-1.005-8.13-1.82a24.756 24.756 0 0 1-14.236 3.882c.037.412.065.828.086 1.251.07 1.482.507 3.142 1.814 3.844a5.053 5.053 0 0 0 3.31.147q5.681-1.063 11.246-2.642c1.066-.3 10.369-1.985 7.368-4.142",
    style: {
      fill: "#222154"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3078",
    d: "M81.469 101.4c-.414 3.091-.507 6.565 1.5 8.952-2.772 1.358-4.7 1.119-7.106 1.341s-5.146-.439-6.378-2.514a7.516 7.516 0 0 1-.75-4.113 28.473 28.473 0 0 1 1.5-8.208c.713-2.1 1.769-4.227 3.649-5.4 1.97-1.233 5.4-1.218 7.061.628 1.971 2.186.873 6.7.524 9.314",
    style: {
      fill: "#474353"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3079",
    d: "M19.96 187.6a11.27 11.27 0 0 0-1.1 1.107c-3.945 4.582-3.028 10.539-2.749 16.066a82.519 82.519 0 0 0 3.584 20.007c3.45 11.323 8.679 22.008 13.887 32.638l9.906 20.226c1.738 3.549 6.791 16.733 9.626 17.116a9.114 9.114 0 0 0 3.585-.48c2.754-.751 5.875-1.82 6.914-4.478.649-1.661-9.72-64.994-12.331-77.554C52.482 218 55.8 224 57.928 229.481q3.563 9.162 7.226 18.285c2.376 5.892 14.533 33.469 15.856 33.958a7.709 7.709 0 0 0 4.579-.251 11.184 11.184 0 0 0 4.363-1.85c2.749-2.259-9.26-44.548-15.653-63.1q-4.791-13.9-10.387-27.509c-1.2-2.911-2.641-9.618-5.146-11.475-2.727-2.02-8.8.045-11.638.828l-17.142 4.743c-3.555.986-7.3 2.091-10.026 4.491",
    style: {
      fill: "#e4cfb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3080",
    d: "M49.227 288.88c-2.322-9.175-5.919-17.948-9.463-26.7s-7.042-17.553-9.162-26.768c-1.086-4.72-1.681-9.527-2.813-14.241s-2.539-9.309-3.314-14.089c-1.127-6.958-1.514-14.009-2.392-21a13.505 13.505 0 0 0-2.123 1.518 11.39 11.39 0 0 0-1.1 1.108c-3.945 4.582-3.028 10.539-2.749 16.066a82.519 82.519 0 0 0 3.584 20.007c3.45 11.323 8.679 22.009 13.887 32.638l9.906 20.226c1.154 2.356 3.77 8.957 6.227 13.242q-.239-1-.488-2.006",
    style: {
      fill: "#d9c2a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3081",
    d: "M82.191 274.62c-.786-1.234-1.453-2.555-2.181-3.825q-1.112-1.935-2.242-3.861c-1.485-2.539-2.977-5.075-4.419-7.64-1.464-2.6-2.877-5.239-4.18-7.929-1.2-2.475-2.239-5.027-3.29-7.568-2.159-5.228-4.238-10.494-6.651-15.613a83.9 83.9 0 0 0-6.9-12.2c1.535 4.57 3.926 9.188 5.6 13.494q3.561 9.162 7.224 18.285c2.377 5.892 14.534 33.469 15.858 33.958a7.706 7.706 0 0 0 4.578-.251l.474-.127a64.465 64.465 0 0 0-3.871-6.728",
    style: {
      fill: "#d9c2a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3082",
    d: "M62.916 145.19a11.134 11.134 0 0 1 .02 2.946c-.167 1.12.08 2.589 1.184 2.843.66.152 1.406-.225 2 .093.582.308.687 1.083 1.04 1.638a3.883 3.883 0 0 0 2.287 1.341c4.421 1.347 7.77 2.261 12.415 1.987l-1.237 4.954a45.249 45.249 0 0 1-21.945 2.423c-2.452-.339-4.985-.935-6.86-2.548-2.839-2.44-3.481-6.72-2.552-10.345s3.152-6.76 5.332-9.8c1.114-1.556 4.357-7.213 6.53-5.315 1.368 1.2 1.188 3.934 1.263 5.557.062 1.413.356 2.826.518 4.226",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3083",
    d: "M88.535 150.391h-.023c-.033.009-.062.023-.094.033-.377.113-.652.2-.778.243-1.352.467-5.407 1.389-5.69 3.267a.963.963 0 0 0 .3.978c.524 1.074 3.032.66 3.795.566a57.585 57.585 0 0 0 11.735-2.748c1.215-.43 3.877-1.107 4.2-2.6.771-3.59-10.087-.733-13.445.261",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3084",
    d: "M89.646 135.474a33.116 33.116 0 0 0-5.582 1.533c-1.419.585-3.042 1.244-2.877 3.063a24.7 24.7 0 0 0 .3 3.292 14.536 14.536 0 0 0 1.643 4.2 10.724 10.724 0 0 0 4.877 4.578 5.856 5.856 0 0 0 8.216-4.883c.006-.049 0-.1.01-.148 2.506-1.481 5.188-4.854 4.257-7.89a3.8 3.8 0 0 0-1.753-2.1 4.042 4.042 0 0 0-3.071-.752 4.362 4.362 0 0 0-1.092.2 3.69 3.69 0 0 0-.461-.78c-1.032-1.242-3.14-.6-4.467-.313m6.13 5.858c-.2-.873-.4-2.114-.694-3.261 1.86-.76 3.979.01 3.781 2.416-.157 1.9-1.317 3.079-2.584 4.251a20.187 20.187 0 0 0-.5-3.406z",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3085",
    d: "M90.435 135.879c-.805.12-1.587.347-2.018.452-.919.224-1.834.472-2.728.784-.953.333-3.579 1.18-3.128 2.646.569 1.852 5.313.176 6.417-.1 1.167-.3 4.175-.821 4.141-2.564-.025-1.329-1.383-1.413-2.684-1.218",
    style: {
      fill: "#474353"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2165",
    style: {
      opacity: 0.51
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2164"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2163",
    style: {
      clipPath: "url(#3ng3dbatjd)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3086",
    d: "M85.588 147.758c-1.422-1.357-1.925-3.778-2.415-5.6a.427.427 0 0 0-.823.223c.53 1.968 1.1 4.517 2.641 5.984.4.378.994-.227.6-.607",
    style: {
      fill: "#e7e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3087",
    d: "M87.192 149.435a5.973 5.973 0 0 0-.263-.265c-.4-.375-1 .229-.6.607.091.086.178.173.264.265.376.4.974-.207.6-.607",
    style: {
      fill: "#e7e6e6"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3088",
    d: "M82.419 155.84a6.546 6.546 0 0 1 2.83-1.669 33.217 33.217 0 0 1 3.41-1.2c.311-.091.726-.137.882.146a.5.5 0 0 1-.079.528 1.444 1.444 0 0 1-.449.338c-.264.149-1.522.648-1.58.929-.1.458 1.085.042 1.316-.009a40.295 40.295 0 0 0 3.782-1.04 65.9 65.9 0 0 0 7.1-2.845 1.047 1.047 0 0 1 .8-.133c.795.314-1.606 3-1.933 3.436a19.276 19.276 0 0 1-15.916 7.8c-.03 0-.06-2.131-.062-2.266a24.815 24.815 0 0 0-.232-3.9.955.955 0 0 1 .131-.115",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3089",
    d: "M55.409 108.519c.088.037.176.076.263.115a15.246 15.246 0 0 1 6.023 5.436c2.325 3.383 1.705 6.7 2.422 10.487.672 3.556 2.112 7.267 1.04 10.895-.745 2.517-2.54 4.037-4.126 5.987a24.544 24.544 0 0 0-3.251 5.749 34.151 34.151 0 0 0-1.872 7.448c-.948 5.884-.258 11.281 3.191 16.265 2.931 4.236 8.009 9.813 3.961 15.126-2.392 3.142-6.455 4.406-10.251 5.494l-18.16 5.205c-4.7 1.347-13.306 5.808-18 5.415-6.867-.574-6.164-14.075-6.364-19.251-.314-8.133.81-16.247 1.376-24.345.618-8.818 3.148-17.82 6.352-26.021 3.858-9.878 14.274-21.547 24.721-24.506a19.162 19.162 0 0 1 12.675.5",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3090",
    d: "M55.94 104.51c-1.7 2.988-4.319 5.688-5.171 9.1-1.033 4.136 1.468 8.54 4.079 11.619a3.552 3.552 0 0 0 2.57 1.561 2.577 2.577 0 0 0 2-1.294c.8-1.264.9-2.966 1.3-4.383.678-2.369 1.215-4.792 2.08-7.1.79-2.112 2.325-3.471 3.276-5.508z",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3091",
    d: "M78.034 106.2c-.278.39-2.22.716-2.654.919-.922.431-1.42 2.375-1.852 3.253a6.818 6.818 0 0 1-2.26 2.948 5.371 5.371 0 0 1-4.225.213 18.516 18.516 0 0 1-10.563-7.413 15.669 15.669 0 0 1 7.92-23.9 15.238 15.238 0 0 1 2.083-.609c3.356-.731 7.439-.49 10.01 2.061 2.875 2.853 4.834 6.661 3.988 10.814a39.256 39.256 0 0 1-1.616 4.767 12.4 12.4 0 0 0-.854 4.975 7.7 7.7 0 0 1 .026 1.971",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3092",
    d: "M71.12 92.82a3.387 3.387 0 0 0-.615.219c-.619.289-.767.985-1.117 1.546A8.007 8.007 0 0 1 68 96.293a4.878 4.878 0 0 1-3.232 1.342c-.388 0-.773-.063-1.16-.037a1.425 1.425 0 0 0-1.029.458c-.34.424-.281 1.843-.4 2.4a20.481 20.481 0 0 0-.453 2.108 18.752 18.752 0 0 0 .355 5.536 2.1 2.1 0 0 1 .024 1.1c-.556 1.576-4.5.494-5.585.25-3.088-.7-5.687-1.565-7.82-3.937a12.933 12.933 0 0 1-2.751-3.424 9.246 9.246 0 0 1-.774-4.223 13.843 13.843 0 0 1 3.8-8.273 30.982 30.982 0 0 1 4.613-4.069 31.379 31.379 0 0 1 4.476-3.178 18.8 18.8 0 0 1 11.47-1.94 14.83 14.83 0 0 1 8.666 4.825 15.8 15.8 0 0 1 3.493 8.132.836.836 0 0 1-.477 1.082.847.847 0 0 1-.37.054 11.72 11.72 0 0 1-5.233-.54c-1.546-.52-2.893-1.535-4.493-1.139",
    style: {
      fill: "#474353"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3093",
    d: "M64.581 97.993a2.668 2.668 0 0 0-.651-1.681 1.421 1.421 0 0 0-1.675-.318 1.759 1.759 0 0 0-.715 1.428 3.935 3.935 0 0 0 2.608 3.894z",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3094",
    d: "M42.764 120.542c2.97 2.28 4.461 5.953 5.725 9.477a112.042 112.042 0 0 1 3.97 12.24c.655 2.81.6 5.879 1.588 8.591a6.788 6.788 0 0 0 4.153 4.35c1 .3 2.333.481 2.571 1.5.118.51-.112 1.079.112 1.553.353.746 1.434.632 2.23.413 1.292-.356 3.11.146 4.544.093 1.684-.062 3.352.462 5.038.195 3.384-.536 7.521-2.758 10.6-4.352.854 3.452 3.2 7.74.658 10.945a11.932 11.932 0 0 1-5.364 3.414 32.1 32.1 0 0 0-5.932 2.479c-1.612 1.008-2.952 2.413-4.584 3.39-3 1.8-6.667 1.97-10.165 2.1-2.884.1-6.025.129-8.319-1.622-1.422-1.085-2.329-2.732-3.743-3.827-1.562-1.209-3.6-1.639-5.237-2.737-2.59-1.733-3.837-4.849-4.793-7.815a96.931 96.931 0 0 1-4.647-30.346c.049-6.922 3.462-16.278 11.592-10.034",
    style: {
      fill: "#a7b30c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3095",
    d: "M72.738 100.07a1.61 1.61 0 0 1 .5-.238 1.682 1.682 0 0 1 .573-.064 1.1 1.1 0 0 1 .98.612.155.155 0 0 1-.084.2.167.167 0 0 1-.063.011h-.009a4.841 4.841 0 0 1-.482-.059l-.4-.065c-.274-.037-.586-.029-.94-.094a.169.169 0 0 1-.138-.195.168.168 0 0 1 .062-.1",
    style: {
      fill: "#29255d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3096",
    d: "M72.043 98.226A6.1 6.1 0 0 1 76.1 98",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#3b373d",
      strokeWidth: "1.641px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3097",
    d: "M71.662 107.377a3.716 3.716 0 0 0 1.413 1.787.841.841 0 0 0 .536.185.641.641 0 0 0 .489-.42c.292-.728-.149-.747-.717-.866a5.329 5.329 0 0 1-1.721-.686",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2169"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2168",
    style: {
      clipPath: "url(#aakk7g5lba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3099",
    d: "M565.022 181.644a31.666 31.666 0 1 1-31.667-31.665 31.666 31.666 0 0 1 31.667 31.665",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3100",
    d: "M565.022 181.644a31.666 31.666 0 1 1-31.667-31.665 31.666 31.666 0 0 1 31.667 31.665",
    style: {
      fill: "#9c96c8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2171"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2170",
    style: {
      clipPath: "url(#6qqnm1ypze)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3101",
    d: "M537.525 216.1a28.232 28.232 0 0 0 .049-11.081 5.1 5.1 0 0 0-.68-2 5.238 5.238 0 0 0-1.176-1.126c-2.572-1.994-5.386-3.591-8.008-5.5-.814-.594-1.184-1.253-2.258-1.077-1.225.2-2.241 1.718-2.671 2.765-1.608 3.932-.291 8.4 1.159 12.4.74 2.05 2.006 4.289 2.364 6.434.3 1.849.213 3.463 1.168 5.219 1.2 2.205 3.91 4.448 6.034 2.243a17.748 17.748 0 0 0 4.019-8.27",
    style: {
      fill: "#a7b30c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3102",
    d: "M565.944 252.307c1.627-6.363 3.851-12.882 3.7-19.508-.3-13.318-3.06-27.409-12.2-37.087a34.422 34.422 0 0 0-8.078-6.325 17.762 17.762 0 0 0-8.844-2.663c-4.892.073-9.215 3.107-12.943 6.274a8.284 8.284 0 0 0-2.77 3.435 6.246 6.246 0 0 0-.024 3.347c.751 3.3 2.925 6.086 4.1 9.261 3.521 9.483-2.125 20.761-8.225 27.846 5.778 23.77 23.928 22.158 40.358 26.213a13.237 13.237 0 0 0 1.025-1.17c2.117-2.767 3.023-6.247 3.891-9.623",
    style: {
      fill: "#b2bd33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3103",
    d: "M530.933 198.113a6.474 6.474 0 0 0 4.222-1.283 12.032 12.032 0 0 0 5.117-8.055q-4.713 2.442-9.421 4.885c-1.107.576-3.041.988-2.875 2.306.149 1.2 1.943 2.033 2.957 2.147",
    style: {
      fill: "#efbe95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3104",
    d: "M514.422 186.114c-.354.578-.782 1.285-.456 1.88a9.932 9.932 0 0 0 1.834 1.784 5.714 5.714 0 0 0 2.669 1.52 2.076 2.076 0 0 0 .785.033 2.37 2.37 0 0 0 1.393-1.037 11.367 11.367 0 0 0 1.752-4.92c.38-2.9.667-5.911-.2-8.7a5.1 5.1 0 0 0-1.785-2.758 3.489 3.489 0 0 0-3.762-.033 3.69 3.69 0 0 0-1.663 2.67c-.065.909.608 1.862.756 2.786a10.046 10.046 0 0 1-1.322 6.78",
    style: {
      fill: "#e7e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3105",
    d: "M516.843 182.254c.04 5.513 3.034 11.4 8.3 13.022 3.559 1.092 7.446.069 10.788-1.578a20.885 20.885 0 0 0 8.853-7.672 16.294 16.294 0 0 0-2.961-19.844c-4.673-4.212-12.957-5.444-18.42-1.941-4.681 3-6.6 12.951-6.56 18.013",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3106",
    d: "M526.223 173.619c-4.005.279-8.422 1.465-10.471 4.923-2.374-4.243-.463-9.969 3.36-12.972s9.021-3.7 13.855-3.2a18.824 18.824 0 0 1 7.288 2.093c2.771 1.55 4.37 3.149 1.44 5.434-4.366 3.4-10.218 3.36-15.472 3.726",
    style: {
      fill: "#e7e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3107",
    d: "M538.506 174.793c-.031.207-.058.415-.079.62-.272 2.647.092 5.316.046 7.975s-.571 5.461-2.322 7.462a28.231 28.231 0 0 0 3.205 1.5c3.429 1.056 7.44-1.428 9.026-4.451 1.85-3.529 1.317-8.722.282-12.334-.837-2.938-.9-6.788-4.634-7.933-1.464-.449-2.964 1.464-3.743 2.512a10.3 10.3 0 0 0-1.781 4.647",
    style: {
      fill: "#e7e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3108",
    d: "M524.782 180.565a11.738 11.738 0 0 1-1.169 3.441 2.1 2.1 0 0 0-.377 1.278c.113.665.842 1 1.475 1.232",
    style: {
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3109",
    d: "M519.134 178.808a2.312 2.312 0 0 1 2.088.09",
    style: {
      strokeWidth: "1.5px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3110",
    d: "M530.012 180.709a2.327 2.327 0 0 1 2.583.764",
    style: {
      strokeWidth: "1.5px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3111",
    d: "M530.06 177.061a6.036 6.036 0 0 1 4.835 1.648",
    style: {
      stroke: "#eeeceb",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3112",
    d: "M519.223 176.013a3.241 3.241 0 0 1 3.058.278",
    style: {
      stroke: "#eeeceb",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 122",
    transform: "translate(522.268 188.348)",
    style: {
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    },
    d: "m0 0 3.304.804"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3113",
    d: "M522.939 189.447a2.416 2.416 0 0 0 2.174.338",
    style: {
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3114",
    d: "M546.277 195.464c-7.3 3-6.992 16.631-7.181 23.17-.046 1.581-.13 3.3-1.158 4.5a5.408 5.408 0 0 1-1.848 1.295c-2.736 1.287-5.83 1.527-8.845 1.748l-14.131 1.032a13.284 13.284 0 0 1 1.274 7.673l25.4 2.744a10.646 10.646 0 0 0 5-.258c2.181-.846 3.543-3.006 4.556-5.116 3.631-7.562 4.751-16.074 5.256-24.363.29-4.788-.741-15.543-8.327-12.423",
    style: {
      fill: "#a7b30c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3115",
    d: "M554.6 207.888c.176-2.881-.131-7.919-2.053-10.8a15.464 15.464 0 0 1 .971 4.484 35.855 35.855 0 0 1-.29 7.394c-.283 2.244-.7 4.468-1.134 6.687-.306 1.552-.729 3.077-1.173 4.594-.483 1.647-.96 3.3-1.507 4.927a17.464 17.464 0 0 1-3.038 5.777 11.016 11.016 0 0 1-4.43 3.146 20.642 20.642 0 0 1-6.287 1.2 62.78 62.78 0 0 1-9.714-.286c-3.826-.36-7.629-.877-11.46-1.165-.019.345-.048.689-.093 1.033l25.4 2.744a10.641 10.641 0 0 0 5-.258c2.182-.846 3.543-3.006 4.558-5.116 3.623-7.563 4.741-16.076 5.246-24.364",
    style: {
      fill: "#a7b30c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2173"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2172",
    style: {
      clipPath: "url(#aakk7g5lba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3117",
    d: "M520.461 69.379a46.111 46.111 0 1 1-16.878-62.99 46.111 46.111 0 0 1 16.878 62.99",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3118",
    d: "M526.85 46.223a46.22 46.22 0 1 1 0-.005z",
    style: {
      fill: "#5d50a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2181"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2180",
    style: {
      clipPath: "url(#t8ijaast0f)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3119",
    d: "M454.876 101.131a75.252 75.252 0 0 1-1.739 16.94 28.907 28.907 0 0 1-3.721 8.583 21.683 21.683 0 0 1-3.038 3.691c-1.13 1.09-2.453 1.542-3.2 3.052a.974.974 0 0 0-.111.822c.151.323.565.406.921.44l4.769.52c.585.064 1.107.24 1.667.335a12.378 12.378 0 0 0 2.114-.167 11.509 11.509 0 0 0 7.28-5.706 20.662 20.662 0 0 0 2.382-9.141c.451-8.168-1.972-16.094-3.521-24.024-.389-1.979-.677-3.964-.96-5.958-.189-1.324-.407-2.709-1.8-1.213-.994 1.059-.706 4.224-.794 5.6-.135 2.074-.2 4.148-.252 6.223",
    style: {
      fill: "#e65b27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3120",
    d: "M445.906 219.966c-.511-1.148-1.06-2.295-1.459-3.451-1.467-4.244-8.346-31.272-9.815-35.515-1.168-3.378-1.219-12.354-5.232-13.292-4.132-.966-16.329 6.721-16.508 10.76-.084 1.9 22.172 41.419 20.265 45.727a21.75 21.75 0 0 1-3.386 4.925 16.25 16.25 0 0 0 16.135-9.154",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3121",
    d: "M445.9 219.966a16.264 16.264 0 0 1-16.14 9.154c-3.205 3.739-7.577 7.672-9.911 10.342a2.668 2.668 0 0 0-.836 1.565 1.78 1.78 0 0 0 1.366 1.617 4.646 4.646 0 0 0 2.253-.081c7.063-1.536 13.226-5.718 19.094-9.949a16.877 16.877 0 0 0 4.487-4.178c1.909-2.938.918-5.709-.313-8.47",
    style: {
      fill: "#474353"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3122",
    d: "M476.386 226.493c-.542-1.205-1.113-2.41-1.533-3.625-1.541-4.457-2.088-12.521-3.629-16.976-1.227-3.548-4.018-27.94-8.231-28.924-4.332-1.016-20.583 2.321-20.766 6.562-.09 2 22.77 42.88 20.767 47.4a22.935 22.935 0 0 1-3.556 5.174 17.075 17.075 0 0 0 16.948-9.611",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3123",
    d: "M476.387 226.492a17.078 17.078 0 0 1-16.949 9.615c-3.366 3.927-7.958 8.057-10.411 10.86a2.784 2.784 0 0 0-.875 1.644 1.863 1.863 0 0 0 1.434 1.7 4.845 4.845 0 0 0 2.365-.086c7.42-1.613 13.89-6.006 20.048-10.448a17.644 17.644 0 0 0 4.711-4.388c2.011-3.089.966-6-.323-8.9",
    style: {
      fill: "#474353"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3124",
    d: "M504.533 165.217a34.691 34.691 0 0 0 12.947-7.4 149.615 149.615 0 0 1-70.807-25.051l-.589.073a148.452 148.452 0 0 0-22.427 4.544c-7.675 2.182-15.762 5.458-19.815 12.323-4.428 7.5-2.737 17.063 0 25.323a133.96 133.96 0 0 0 10.675 25.3c2.032 3.509 3.986 7.074 5.907 10.63 1.461 2.708 1.94 6.619 4.985 8.109a8.181 8.181 0 0 0 4.142.542 41.022 41.022 0 0 0 13.438-3.422 5.583 5.583 0 0 0 2.686-1.907c.769-1.231.057-1.831-.416-2.844a32.337 32.337 0 0 1-1.415-4.42l-3-10.02q-3-10.021-6-20.049a23.927 23.927 0 0 1-1.459-8.6 8.113 8.113 0 0 1 4.482-7.023c-.785 9.553 1.514 19.015 4.931 27.875a143.585 143.585 0 0 0 5.933 13.288c2.148 4.228 3.209 8.854 4.528 13.448a7.675 7.675 0 0 0 1.76 3.592 7.179 7.179 0 0 0 4.612 1.472 22.466 22.466 0 0 0 9.073-.948 10.628 10.628 0 0 0 6.52-6.051c1.26-3.521-.686-6.021-2.134-9.02a54.586 54.586 0 0 1-3.962-11.156 112.59 112.59 0 0 1-3.164-26.875c6.589.489 13.659 1.761 20.232 1.313 2.881-.2 5.923-.589 8.813-.979 3.008-.4 6.594-2.07 9.524-2.07",
    style: {
      fill: "#474353"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3125",
    d: "M473.1 75.912a15.593 15.593 0 0 0 13.2 2.031 22.569 22.569 0 0 0 11.179-7.757 34.719 34.719 0 0 0 4.043-6.418 43.667 43.667 0 0 0-12.444-2.168 37.216 37.216 0 0 0-21.019 5.392 12.394 12.394 0 0 0 5.036 8.919",
    style: {
      fill: "#efbe95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3126",
    d: "m525.275 129.8-1.824-32.21c-.486-8.6-1.249-17.9-6.955-24.357a34.106 34.106 0 0 0-14.971-9.466 34.669 34.669 0 0 1-4.042 6.419 22.572 22.572 0 0 1-11.18 7.757 15.588 15.588 0 0 1-13.203-2.032 12.4 12.4 0 0 1-5.036-8.921 25.6 25.6 0 0 0-9.636 10.958c-4.807 10.544-4.043 22.8-1.555 34.125 1.4 6.392 2.778 14.415-2.469 18.329-2.185 1.625-5 2.031-7.72 2.365a149.613 149.613 0 0 0 70.807 25.052 24.21 24.21 0 0 0 5.934-8.325c2.564-6.139 2.231-13.052 1.855-19.7",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3127",
    d: "M460.708 55.271a17.857 17.857 0 0 0 3.584 9.285c3.612 4.12 9.908 4.777 15.231 3.479a27.1 27.1 0 0 0 14.49-9.147c3.973-4.875 6.581-11.493 5.608-17.774-.707-4.543-4.344-8.2-8.5-10.156a32.765 32.765 0 0 0-16.865-3.3c-6.991.771-11.338 5.757-13.168 12.432a36.349 36.349 0 0 0-.433 14.79c.014.13.032.26.053.391",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3128",
    d: "m468.535 47.983-3.257 4.1a1.921 1.921 0 0 0-.49.938 1.638 1.638 0 0 0 .762 1.343 4.375 4.375 0 0 1 1.185 1.084",
    style: {
      strokeWidth: "1.551px",
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3129",
    d: "M474.427 48.719a3.483 3.483 0 0 1 3.384.97",
    style: {
      stroke: "#131516",
      strokeWidth: "1.551px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3130",
    d: "M461.975 46.005a2.627 2.627 0 0 1 3.431.724",
    style: {
      stroke: "#131516",
      strokeWidth: "1.551px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3131",
    d: "M462.364 41.693a5.926 5.926 0 0 1 5.837.715",
    style: {
      stroke: "#a09892",
      strokeWidth: "2.62px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3132",
    d: "M474.744 43.983a7.041 7.041 0 0 1 6.327 2.2",
    style: {
      stroke: "#a09892",
      strokeWidth: "2.62px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3133",
    d: "M471.993 52.293c.041.085.086.17.135.256a4.876 4.876 0 0 0 7.945.781c.829-1 1.934-3.484.876-4.6a10.706 10.706 0 0 0-5.581-2.4 4.124 4.124 0 0 0-2.129.081c-.906.345-1.149 1.107-1.372 1.959a5.532 5.532 0 0 0 .126 3.923z",
    style: {
      strokeWidth: "1.792px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3134",
    d: "M458.2 48.332c.04.087.085.173.136.261a4.917 4.917 0 0 0 4.116 2.574 4.509 4.509 0 0 0 3.528-1.668c.784-1 1.811-3.5.781-4.642a10.353 10.353 0 0 0-5.395-2.5 3.775 3.775 0 0 0-2.049.055c-.866.335-1.082 1.1-1.29 1.963a5.888 5.888 0 0 0 .173 3.957z",
    style: {
      strokeWidth: "1.768px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3135",
    d: "M467.19 47.224a5.493 5.493 0 0 1 4.333 1.594",
    style: {
      strokeWidth: "1.792px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 123",
    transform: "translate(481.458 49.596)",
    style: {
      strokeWidth: "1.792px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    },
    d: "M0 1.112 7.755 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3136",
    d: "M462.2 24.983a9.9 9.9 0 0 0-3.241 9.682 3.381 3.381 0 0 0 1.986 2.495c1.2.367 2.43-.39 3.663-.646 2.736-.57 5.23 1.241 7.655 2.187 2.6 1.013 4.882.183 7.514.576 5.081.758 6.995 6.542 6.966 11.016-.02 2.646-.686 5.416.311 7.862a7.378 7.378 0 0 0 6.2 4.279c3.464.3 6.015-1.365 8.5-3.4a7.635 7.635 0 0 1 2.844-.906 4.715 4.715 0 0 0 3.281-4.655c-.159-2.642-2.487-4.6-3.4-7.093-1.4-3.812.668-8.4-1.208-12-1.407-2.7-4.583-3.945-6.571-6.248a25.169 25.169 0 0 0-2.888-3.534c-2.877-2.3-6.465.011-9.583-1.044a33.559 33.559 0 0 0-11.381-2.188 16.373 16.373 0 0 0-10.373 3.385z",
    style: {
      fill: "#131516"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3137",
    d: "M463.718 57.4a5.312 5.312 0 0 0 1.642.156 6.018 6.018 0 0 1 1.9.562 7.481 7.481 0 0 0 3.177.564",
    style: {
      strokeWidth: "1.551px",
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3138",
    d: "M464.748 58.964a7.277 7.277 0 0 0 3.577.7",
    style: {
      strokeWidth: "1.551px",
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3139",
    d: "M428.8 153.992a1.941 1.941 0 0 0 1.218 1.747 4.563 4.563 0 0 0 2.223.257 29.937 29.937 0 0 0 9.007-2.66c-2.416 0-4.887-.365-7.3-.542-1.225-.1-5.038-1.038-5.148 1.2",
    style: {
      fill: "#aba4b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3140",
    d: "M477.1 144.081a13.521 13.521 0 0 0-4.007-6.247c-5.8-5.444-10.522-6.467-18.331-5.773A23.716 23.716 0 0 0 441.9 137.6a3.928 3.928 0 0 1-4.479.576 9.841 9.841 0 0 0-4.62-1.146 11.512 11.512 0 0 0-9.225 5.573 7.887 7.887 0 0 0-1.6 5.106 8 8 0 0 0 3.049 5.021 12.5 12.5 0 0 0 7.438 2.322 37.307 37.307 0 0 0 7.854-.977 3.767 3.767 0 0 0-2 .406 1.3 1.3 0 0 0-.479 1.771 1.777 1.777 0 0 0 1.247.519 27.373 27.373 0 0 0 4.518.012l23.3-1.234a17.685 17.685 0 0 0 5.02-.752 8.855 8.855 0 0 0 5.178-10.715",
    style: {
      fill: "#c6d8e7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2176",
    style: {
      isolation: "isolate",
      opacity: 0.42
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2175"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2174",
    style: {
      clipPath: "url(#4rsrvikkeg)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3141",
    d: "M470.839 136.251a24.224 24.224 0 0 0-5.731-2.234 25.161 25.161 0 0 0-11.4-.082 23.942 23.942 0 0 0-9.073 3.63c-1.408 1-2.624 2.313-4.4 2.613a8.122 8.122 0 0 1-5.066-1.3 11.033 11.033 0 0 0-4.561-1.3c-.3-.012-.6 0-.9.016a9.143 9.143 0 0 1 3.1-.568 9.832 9.832 0 0 1 4.621 1.145 3.926 3.926 0 0 0 4.479-.575 23.711 23.711 0 0 1 12.864-5.54c7.512-.667 12.171.271 17.678 5.185a19.947 19.947 0 0 0-1.606-.995",
    style: {
      fill: "#0099d6"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3142",
    d: "M434.45 140.1a20.286 20.286 0 0 1 4.17-4.675 10.264 10.264 0 0 1-.794 8.186z",
    style: {
      fill: "#c6d8e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3143",
    d: "M427.791 140.252a17.583 17.583 0 0 0-4.253-3.863 7.15 7.15 0 0 0 .625 6.929z",
    style: {
      fill: "#c6d8e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3144",
    d: "M429.275 149.231a1.1 1.1 0 0 1-.619-.248 3.719 3.719 0 0 1-.757-.736.152.152 0 0 1 .043-.212.151.151 0 0 1 .2.025 3.428 3.428 0 0 0 .7.677.7.7 0 0 0 .5.183.827.827 0 0 0 .316-.179 2.877 2.877 0 0 0 .764-.756.152.152 0 0 1 .208-.054.15.15 0 0 1 .055.206 3.13 3.13 0 0 1-.839.843 1.071 1.071 0 0 1-.445.236.625.625 0 0 1-.123.012",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3145",
    d: "M429.268 150.351a.152.152 0 0 1-.149-.136 3.459 3.459 0 0 1 .033-1.112.146.146 0 0 1 .164-.123h.014a.153.153 0 0 1 .121.179 3.218 3.218 0 0 0-.029 1.013.154.154 0 0 1-.132.171z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3146",
    d: "M425.106 146.858a1.2 1.2 0 0 1-1.045-.637.152.152 0 0 1 .264-.15l.007.013a.889.889 0 0 0 .772.471.9.9 0 0 0 .772-.476.152.152 0 0 1 .277.125l-.005.011a1.209 1.209 0 0 1-1.045.64z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3147",
    d: "M433.54 146.858a1.2 1.2 0 0 1-1.045-.635.151.151 0 0 1 .064-.205.156.156 0 0 1 .205.065.868.868 0 0 0 1.547 0 .151.151 0 0 1 .207-.058.153.153 0 0 1 .069.183v.011a1.208 1.208 0 0 1-1.044.64z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2179",
    style: {
      opacity: 0.62,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2178"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2177",
    style: {
      clipPath: "url(#u6r8zk319h)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3148",
    d: "M453.516 156.17c-.417-.626.169-1.438.78-1.876a3.4 3.4 0 1 0 3.578-4.964 4.526 4.526 0 0 1 1.234-4.469 5.922 5.922 0 0 1 5.048-.857 10.134 10.134 0 0 1 3.959 1.664 8.436 8.436 0 0 0-2.236-1.881 7.259 7.259 0 0 0-5.482-.649 5.834 5.834 0 0 0-4.3 4.043 6.091 6.091 0 0 0-.085 3.1c.155.561.868 2.367 1.6 2.422a7.244 7.244 0 0 0-4 .458 2.582 2.582 0 0 0-1.284 3.155l1.3-.041a.86.86 0 0 1-.112-.1",
    style: {
      fill: "#0099d6"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3149",
    d: "M463.81 128.393a6.22 6.22 0 0 0-4.342 2.473 9.516 9.516 0 0 0-1.381 2.257c-.118.28-.479.932-.394 1.239.3 1.059 1.9-.271 2.346-.519l3.329-1.9a10.81 10.81 0 0 0-4.2 3.681 9.862 9.862 0 0 0-1.169 2.7c-.067.271-.358 1.01-.243 1.267.63 1.38 3.3-1.162 3.864-1.565a2.881 2.881 0 0 0-.709 2.388c.5 1.456 2.692-.329 3.318-.786 1.465-1.068 2.573-2.38 4.58-1.915a23.905 23.905 0 0 1 3.114 1.247c2.367.918 7.205 1.573 6.619-2.322a7.7 7.7 0 0 0-3.215-4.662 17.53 17.53 0 0 0-8-3.411 13.411 13.411 0 0 0-3.516-.167",
    style: {
      fill: "#efbe95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3150",
    d: "M498.332 91.481a41.564 41.564 0 0 0-1.8 10.347 31.255 31.255 0 0 1-.226 5.671c-.337 1.251-1.37 2.447-1.8 3.732-1.318 3.958-1.044 8.165-1.648 12.243-.439 2.953.272 7.55-2.8 9.208a14.349 14.349 0 0 1-12.446.622 3.1 3.1 0 0 0-2.007-.507 2.4 2.4 0 0 0-1.446 1.986c-.89 4.148 1.5 8.492 4.965 10.94a24.024 24.024 0 0 0 12.026 3.666 34.044 34.044 0 0 0 11.164-.677c3.086-.784 6.9-2.357 8.937-4.938 2.239-2.829 1.2-8.063 1.249-11.439.057-3.894 1.269-7.611 1.788-11.469a157.714 157.714 0 0 0 1.3-28.007c-.183-4.13-.948-11.9-6.309-12.772s-9.6 7.306-10.948 11.394",
    style: {
      fill: "#d85914"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3151",
    d: "M450.186 131.254a3.994 3.994 0 0 1 2.574 2.864 1.4 1.4 0 0 1-.2 1.154 1.2 1.2 0 0 1-1.293.271 3.5 3.5 0 0 1-1.153-.784 3.555 3.555 0 0 1-.029 1.641 1.217 1.217 0 0 1-1.241.881c-.393-.066-.75-.394-1.137-.3-.331.079-.508.419-.71.693a2.674 2.674 0 0 1-3.454.582 3.206 3.206 0 0 1-1.327-3.357c.675-3.049 5.339-4.632 7.97-3.645",
    style: {
      fill: "#efbe95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3152",
    d: "M477.252 145.36c1.809 2.878.49 8.993-1.343 10.7a12.58 12.58 0 0 1-6.874 2.708 29.383 29.383 0 0 0-7.325 1.5 6.9 6.9 0 0 0-4.5 5.511c-.053.927.163 1.852.107 2.775a2.47 2.47 0 0 1-1.346 2.255 2.05 2.05 0 0 1-2.167-.665 3.939 3.939 0 0 1-.845-2.222 8.9 8.9 0 0 1 2.592-6.957 13.059 13.059 0 0 1 6.691-3.5c1.616-.345 3.274-.454 4.882-.834a7.732 7.732 0 0 0 4.264-2.348 4 4 0 0 0 .5-4.6z",
    style: {
      fill: "#c6d8e7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2183"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2182",
    style: {
      clipPath: "url(#aakk7g5lba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3154",
    d: "M242.776 17.42a33.852 33.852 0 1 1-33.852 33.852 33.852 33.852 0 0 1 33.852-33.852",
    style: {
      fill: "#2e2365"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2185"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2184",
    style: {
      clipPath: "url(#h43eoagsti)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3155",
    d: "M257.335 71.816c1.48 4.165 2.53 8.609 5.209 12.125.429.563.926 1.219.75 1.906a2.135 2.135 0 0 1-.8 1.024 11.3 11.3 0 0 1-3.558 2.135 5.257 5.257 0 0 1-4.057-.19 6.262 6.262 0 0 1-2.8-4.075c-1.272-4.759.317-9.8-.041-14.715a18.666 18.666 0 0 0-1.281-5.541c-.187-.468-1.034-1.621-.646-2.066.483-.557 1.335.142 1.707.422 2.782 2.1 4.385 5.792 5.517 8.975",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3156",
    d: "M234.142 107.406c.335-1.936 2.4-3 4.245-3.677a82.2 82.2 0 0 1 11.81-2.97c3.764-.781 6.472-1.383 10.411-.224 2.731.8 5.357 1.9 8.081 2.689q1.383.407 2.8.674a7.2 7.2 0 0 1 5.212 3.4c-5.192-.552-8.719 3.369-11.244 8.3-.532 0-.934.761-1.867.656-2.42-.269-5.858-1.371-8.272-1.7l-14.493-1.977a11.87 11.87 0 0 1-4.546-1.254 4.044 4.044 0 0 1-2.137-3.917",
    style: {
      fill: "#474353"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3157",
    d: "M255.328 70.718c1.194 2.89 2.414 5.922 1.7 8.93-.488 2.061-1.83 3.8-2.821 5.669-1.964 3.717-.608 7.929 2.415 10.844 1.018.98 2.321 1.995 2.284 3.407-.04 1.507-1.584 2.466-2.954 3.094a68.611 68.611 0 0 1-12.686 4.367c-3.1.736-8.464 3-10.862.018a10.736 10.736 0 0 1-1.826-5.586 99.852 99.852 0 0 1 .349-25.623c.558-3.987.88-9.138 2.568-12.824 1.34-2.928 5.128-3.789 8.11-4.058 3.81-.343 8.129.62 10.449 3.962a17.578 17.578 0 0 1 2.046 4.632c.339 1.03.78 2.089 1.227 3.168",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3158",
    d: "M230.563 78.782q.188 4.475.688 8.929c.165 1.467.364 2.93.538 4.4.133 1.1.267 2.2.424 3.3a44.946 44.946 0 0 0 1.537 7.211 16.844 16.844 0 0 0 3.027 5.9 4.823 4.823 0 0 1-4.372-1.469 10.734 10.734 0 0 1-1.824-5.587 98.789 98.789 0 0 1-.018-22.684",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3159",
    d: "M232.716 62.011a11.234 11.234 0 0 0-2.512 2.568 19.313 19.313 0 0 0-2.251 5.377A104.8 104.8 0 0 0 225 83.042c-.4 2.507-.671 5.029-1.054 7.536-.316 2.078-1.145 4.842-.06 6.813.906 1.645 2.058 3.323 3.893 3.984a8.419 8.419 0 0 0 5.5-.172 4.158 4.158 0 0 0 2.223-1.458 3.312 3.312 0 0 0 .128-3.043c-.934-2.275-2.93-3.7-3.442-6.227a27.527 27.527 0 0 1-.027-6.907 66.728 66.728 0 0 1 1.712-11.958 67.769 67.769 0 0 1 2.826-9.023c.633-1.624.72-3.073-1.63-2a12.606 12.606 0 0 0-2.356 1.424",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3160",
    d: "M257.315 59.075a3.686 3.686 0 0 1-.448 1.725 10.7 10.7 0 0 0-.8 1.3c-.484 1.222.3 2.6.09 3.9-.081.493-.43 1.036-.928 1-.419-.033-.683-.451-.906-.809a8.269 8.269 0 0 0-1.953-2.149 20.757 20.757 0 0 0-2.651-1.449c-1.693-.962-3.364-2.143-3.931-4.118s.152-4.041.86-5.957l2.52-6.82c.679-1.839 1.439-3.788 3.034-4.929 3.827-2.744 5.939 1.175 6.062 4.347.108 2.834-.561 5.621-.738 8.439-.075 1.185-.014 2.344-.154 3.521-.083.676-.027 1.343-.057 2",
    style: {
      fill: "#ad622a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3161",
    d: "M247.331 62a5.213 5.213 0 0 1-5.023-1 7.24 7.24 0 0 1-2.387-4.665 3.05 3.05 0 0 1 .517-2.436 3.159 3.159 0 0 1 2.814-.664c1.44.2 5.053 1.073 5.683 2.637.554 1.382-1.361 4.568-1.6 6.134",
    style: {
      fill: "#efbe95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3162",
    d: "M256.366 50.679c-.812 2.922-2.868 5.687-5.794 6.481a7.852 7.852 0 0 1-6.593-1.423 11.868 11.868 0 0 1-3.941-5.633 13.4 13.4 0 0 1 .818-11.195 8.017 8.017 0 0 1 10.966-2.876c.168.1.332.2.492.313 4.435 2.933 5.384 9.533 4.052 14.333",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3163",
    d: "M254.415 46.045a6.072 6.072 0 0 0-3.457-.531 19.18 19.18 0 0 1-3.823.2 13.664 13.664 0 0 1-4.1-1.49.8.8 0 0 0-.568-.109c-.315.1-.375.514-.38.845-.021 1.735.1 3.349-1.454 4.539.333-.254 1.534 3.841 1.609 4.148a10.226 10.226 0 0 1 .524 4.081 7.259 7.259 0 0 1-2.644 4.656c-1 .794-2.293 1.291-3.268.31-.3-.3-.283-.718-.684-.987a3.038 3.038 0 0 0-2.316-.068 9.2 9.2 0 0 0-2.844 1.721c-.55-2.689 1.688-6.625 2.892-8.961 3.114-6.042.787-14.374 6.979-18.831a10 10 0 0 1 9.991-.941 12.182 12.182 0 0 1 5.79 4.9 10.026 10.026 0 0 1 1.3 3.81 9.112 9.112 0 0 1-.421 2.777c-.1.519-.049 1.033-.2 1.554a4.89 4.89 0 0 1-.269.712c-.067.14-.336.457-.336.6a2.275 2.275 0 0 0-.67-1.36 6.847 6.847 0 0 0-1.416-1.42 1.571 1.571 0 0 0-.235-.156",
    style: {
      fill: "#ad622a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3164",
    d: "M247.055 49.932a2.3 2.3 0 0 1-1.849-.093",
    style: {
      strokeWidth: "1.729px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3165",
    d: "M254.205 49.467a2.253 2.253 0 0 1-1.282.185",
    style: {
      strokeWidth: "1.729px",
      stroke: "#29255d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3166",
    d: "M250.87 52.792a1.809 1.809 0 0 1-1.589.13",
    style: {
      stroke: "#ecbb91",
      strokeWidth: "1.551px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3167",
    d: "M248.4 54.586a27.3 27.3 0 0 1 2.86-.109s-.8 1.008-1.487.954a2.007 2.007 0 0 1-1.373-.845",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3168",
    d: "M241.568 49.58a2.127 2.127 0 0 0-.678-.763.728.728 0 0 0-.933.125.86.86 0 0 0-.056.729 4.359 4.359 0 0 0 2.091 2.2z",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3169",
    d: "M262.116 97.614q3.154-.48 6.345-.712a79.886 79.886 0 0 1 9.663-.11c1.508.075 3.824-.153 4.834 1.262a5.409 5.409 0 0 1 .757 2.221 140.628 140.628 0 0 1 1.939 15.63 31.436 31.436 0 0 0 1.128 7.857 8.777 8.777 0 0 0 .659 1.5 5.381 5.381 0 0 0-2.73 3.451 10.053 10.053 0 0 1-4.968-3.24c0-.519.022-1.039.036-1.549.068-2.715-1.235-4.767-2.161-7.229a62.165 62.165 0 0 1-2.978-9.571c-4.658 1.934-8.873 3.578-13.123 5-1.567-4.749-1.851-10.431.6-14.51",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3170",
    d: "M279.753 128.758a12.582 12.582 0 0 1-.008-3.29 10.04 10.04 0 0 0 4.968 3.24 5.383 5.383 0 0 1 2.73-3.451c1.666 3 4.671 4.166 6.841 6.92a2.659 2.659 0 0 1 .441 2.871 2.051 2.051 0 0 1-.8.752 21.226 21.226 0 0 1-14.172-7.042",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3171",
    d: "M293.928 135.8a2.842 2.842 0 0 1-1.241.343 6.082 6.082 0 0 1-2.346-.486c-3.244-1.194-8.538-3.27-10.37-6.359a2.286 2.286 0 0 1-.22-.54c3.977 3.186 8.345 6.036 14.177 7.042",
    style: {
      fill: "#b7873d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3172",
    d: "M235.121 108.543c2.407-4.585 11.453-7.108 16.1-8.493a80.421 80.421 0 0 1 10.9-2.438c-2.45 4.079-1.569 10.97 0 15.713-4.833 1.614-10.311 1.726-15.94 2.833-1.951.384-4.114.661-5.809-.375-2.418-1.474-6.566-4.736-5.251-7.24",
    style: {
      fill: "#574887"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3173",
    d: "M275.127 158.025a4.235 4.235 0 0 1-4.511.05 9.8 9.8 0 0 1-3.259-3.421 30.6 30.6 0 0 1-2.41-4.533 6.681 6.681 0 0 1-.632-2.266 3.6 3.6 0 0 1 .647-2.6z",
    style: {
      fill: "#b7873d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3174",
    d: "M264.653 146.524a6.223 6.223 0 0 1 .81-2.335 9.814 9.814 0 0 0 2.48 5.023c1.173-1.579 3.026-2.669 4.869-2.23a22.951 22.951 0 0 0 2.176 6.3c.678 1.3 1.483 2.9.67 4.124a2.39 2.39 0 0 1-2.083.959 4.542 4.542 0 0 1-2.229-.8c-2.173-1.39-3.577-3.683-4.9-5.9-.954-1.582-1.939-3.3-1.793-5.141",
    style: {
      fill: "#e96627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3175",
    d: "M263.784 115.009a9.522 9.522 0 0 1 9.416-8.479 5.807 5.807 0 0 1 3.113.759c.091.056.175.115.256.175 1.445 1.084 1.317 2.763 1.486 4.441a36.525 36.525 0 0 1-.067 6.318c-.54 7.473-2.454 14.763-4.36 21.981-.628 2.383-1.345 3.773-.923 6.27.028.171.073.338.105.507-1.842-.439-3.7.651-4.87 2.23a9.812 9.812 0 0 1-2.479-5.023 6.818 6.818 0 0 0 .807-2.155c.271-2.052.222-4.245.388-6.322.371-4.638.771-9.272 1.154-13.909.135-1.6.333-4.031-.853-5.347-.43-.477-2.946-.6-3.119-.91a.9.9 0 0 1-.054-.536",
    style: {
      fill: "#efbe95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3176",
    d: "M233.471 75.521a49.2 49.2 0 0 1 .86 10.461c-.06 2.353-.215 4.724-1.663 6.683-.6-1.748.022-4.169.13-5.987l.336-5.579c.1-1.678.651-3.935.337-5.578",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3177",
    d: "m270.3 86.927 5.335-9.476-22.746 6.7L266.185 88z",
    style: {
      fill: "#c85d28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3178",
    d: "m273.381 78.026 1.227-.607s-5.4 7.142-5.154 9.482l-1.861-2.561.54-3.232s2.33-1.471 2.4-1.588 2.848-1.494 2.848-1.494",
    style: {
      fill: "#c8c3c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3179",
    d: "M269.684 87.048a6.172 6.172 0 0 1 .4-5.45c.984-1.911 2.353-2.126 4.53-4.406l-19 5.589 3.246 3.919z",
    style: {
      fill: "#eeeceb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3180",
    d: "M254.735 79.35a138.8 138.8 0 0 0 12.544 6.377c.51.228 1.889 1.051 2.4.674-.222-.806-1.572-1.751-2.214-2.289a20.322 20.322 0 0 0-2.719-1.924 20.545 20.545 0 0 0-6.251-2.427 19.472 19.472 0 0 0-3.76-.411",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3181",
    d: "m270.293 86.927-14.525-8.81-20.6 12.755 11.841 8.962z",
    style: {
      fill: "#df7d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3182",
    d: "M247.183 88.428a7.927 7.927 0 0 1 2.3-1.3c.991-.24 1.979-.485 2.969-.728a.288.288 0 0 1 .127-.011.192.192 0 0 1 .133.176.493.493 0 0 1-.055.226 2.441 2.441 0 0 1-1.934 1.415 5.009 5.009 0 0 1 .969.2c.4.048.813.066 1.221.08a16.136 16.136 0 0 1 2.345.159c.417.075 1.72.251 1.837.817.209 1.021-2.951.268-3.5.157a13.994 13.994 0 0 1 4.418 1.755c-.04.335-.443.462-.751.6-.577.262-.658.789-1.084 1.139a4.133 4.133 0 0 1-1.642.6 11.35 11.35 0 0 1-3.362.124c-2.03-.173-4.12-.555-6.068.042-3.188.978-5.115 3.914-8.084 5.355a5.465 5.465 0 0 1-4.006.621 3.331 3.331 0 0 1-2.186-3.491c.4-3.028 5-3.95 7.351-4.6q2.438-.676 4.919-1.186a11.08 11.08 0 0 0 4.083-2.15",
    style: {
      fill: "#edcea3"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2187"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2186",
    style: {
      clipPath: "url(#aakk7g5lba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3184",
    d: "M375.872 17.42a22.236 22.236 0 1 1-22.236 22.236 22.235 22.235 0 0 1 22.236-22.236",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3185",
    d: "M114.349 155.172a13.236 13.236 0 1 1-13.236 13.236 13.236 13.236 0 0 1 13.236-13.236",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3186",
    d: "M140.292 78.839a8.344 8.344 0 1 1 6.9 9.57 8.344 8.344 0 0 1-6.9-9.57",
    style: {
      fill: "#99d6ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3187",
    d: "M0 227.04a47.674 47.674 0 1 1 47.675 47.675A47.673 47.673 0 0 1 0 227.04",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3188",
    d: "M0 227.04a47.674 47.674 0 1 1 47.675 47.675A47.673 47.673 0 0 1 0 227.04",
    style: {
      fill: "#2e2365"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2189"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2188",
    style: {
      clipPath: "url(#zw07f9n2sj)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3189",
    d: "M40.484 271.061c-.133-4.532.1-18.868-3.809-22.164-8.9-7.512-14.563 22.4-15.835 31.608 6.429.821 13.567 1.478 19.563 3.613.169-4.35.21-8.706.081-13.057",
    style: {
      fill: "#d85914"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3190",
    d: "M27.141 284.384q-.024-2.551-.087-5.1c-.152-6.183-.476-12.411.48-18.522.721-4.61 2.379-11.636 6.245-14.738 2.737-2.2 7.842-3.069 11.22-3.706a45.772 45.772 0 0 1 29.081 4.67c5.072 2.684 6.215 3.794 7.676 9.5a120.433 120.433 0 0 1 2.957 16.832c1.245 11.427 1.183 22.949 1.113 34.428q-.129 21.554-.261 43.109c-15.085 3.456-25.389 2.137-40.32 1.788-4.876-.114-16.794-3.814-20.75-6.668 0 0 .114-16.955.857-24.046a331.118 331.118 0 0 0 1.789-37.547",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3191",
    d: "M58.882 242.3c.034.1.072.194.11.3a3.152 3.152 0 0 1-.062 2.989 3.684 3.684 0 0 1-1.581 1.03l-13.094 5.594c-2.315-4.692-2.272-9.864-2.462-14.937a6.65 6.65 0 0 1 .476-3.422c1.507-2.813 6.907-3.516 9.694-3.947a14.774 14.774 0 0 1 3.127-.257 9.916 9.916 0 0 1 3.092 1.14q.1 4.394.193 8.789a7.6 7.6 0 0 0 .507 2.721",
    style: {
      fill: "#efbe95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3192",
    d: "M57.492 231.924c-2.81 4.223-6.811 7.859-11.7 9.221-1.805.5-3.943.994-5.663.156a20.242 20.242 0 0 1-5.22-3.773c-8.145-7.981-8.682-23.331-1.194-32.031a17.57 17.57 0 0 1 19.588-4.6c13.98 5.878 10.95 20.873 4.189 31.032",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3193",
    d: "M26.711 212.822c-2.589-2.624-3.4-8.081-3.189-11.205 1.8 1.432 4.445 1 6.563.1 2.639-1.117 5-2.272 7.88-2.616a99.544 99.544 0 0 1 14.079-.5 9.407 9.407 0 0 1 8.464 6.015 5.366 5.366 0 0 1 5.036 2.274 8.722 8.722 0 0 1 1.442 5.525 29.938 29.938 0 0 1-1.517 7.579c-.826 2.5-2.417 4.566-3.515 6.916a34.952 34.952 0 0 1-2.112 3.391 6.963 6.963 0 0 1-1.307 1.646c-.174.153-1.6.923-1.6 1 .389-3.3-.418-6.6-1.019-9.861s-.984-6.726.2-9.824c-.413 1.079-7.958 2.232-9.2 2.376a36.82 36.82 0 0 1-8.682.224q-4.622-.607-9.168-1.666a4.849 4.849 0 0 1-2.355-1.374",
    style: {
      fill: "#514c49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3194",
    d: "M55.355 224.068a3.4 3.4 0 0 1 1.865-1.288 2 2 0 0 1 2.06.708 2.091 2.091 0 0 1 .148 1.912 4.555 4.555 0 0 1-1.16 1.6 11.571 11.571 0 0 1-3.567 2.357z",
    style: {
      fill: "#edcea3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3195",
    d: "M35.066 223.543a7.931 7.931 0 0 1 .922 4 20.407 20.407 0 0 1-.647 3.786c-.292 1.289 1.921 1.2 2.766 1.123",
    style: {
      strokeWidth: "1.443px",
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3196",
    d: "M30.761 225.084a2.43 2.43 0 0 1 2.525-.005",
    style: {
      stroke: "#474353",
      strokeWidth: "1.443px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3197",
    d: "M41.238 225.442a2.43 2.43 0 0 1 2.525-.005",
    style: {
      stroke: "#474353",
      strokeWidth: "1.443px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 124",
    transform: "translate(36.534 235.358)",
    style: {
      strokeWidth: "1.443px",
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    },
    d: "M3.805.01 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3198",
    d: "M39.879 236.392a5.249 5.249 0 0 1-1.871.459",
    style: {
      strokeWidth: "1.443px",
      stroke: "#eabd94",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3199",
    d: "M40.84 222.445a5.37 5.37 0 0 1 4.77.682",
    style: {
      stroke: "#514c49",
      strokeWidth: "2.287px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3200",
    d: "M30.337 221.674a4.966 4.966 0 0 1 3.375.018",
    style: {
      stroke: "#514c49",
      strokeWidth: "2.287px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3201",
    d: "M63.011 245.724c-.883 1.589-2.619 2.267-4.287 2.729-1.877.52-3.785.91-5.651 1.476a31.915 31.915 0 0 0-10.139 4.914 30.714 30.714 0 0 1-1.636-7.154c-.072-.7-1.17-.7-1.1 0a32.064 32.064 0 0 0 1.934 8.191.559.559 0 0 0 .917.242 31.105 31.105 0 0 1 11.43-5.46c3.173-.889 7.686-1.157 9.478-4.384.345-.618-.6-1.172-.946-.554",
    style: {
      fill: "#eccba2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3202",
    d: "M80.89 255.846c-3.489-5.677-11.306-7.242-14.866-.777a19.936 19.936 0 0 0-1.93 7.474c-.4 3.505 1.2 13.913 2.886 24.234a152.077 152.077 0 0 1 19.431-3.677c-.689-5.567-3.564-24.069-5.521-27.257",
    style: {
      fill: "#d85914"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2191"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2190",
    style: {
      clipPath: "url(#aakk7g5lba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3204",
    d: "M498.276 261.466a6.23 6.23 0 1 1 7.706-4.271 6.229 6.229 0 0 1-7.706 4.271",
    style: {
      fill: "#99d6ef"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPhoto);
export default __webpack_public_path__ + "static/media/hero-photo.34980c927f54e7de65f634fa05d465c1.svg";
export { ForwardRef as ReactComponent };